import React from 'react';
import { withTranslation } from 'react-i18next';
import FontAwesome from 'react-fontawesome';
import LanguageMenu from '../languages/LanguageMenu';
import authUtils from '../auth/utils';
import { Nav, NavItem, MenuItem } from 'react-bootstrap';
import NavDropdownHover from './NavDropdownHover';
import { IndexLinkContainer } from 'react-router-bootstrap';
import { MAIN_MENU } from '../dashboard/routes';
import AnonymousMenu from './AnonymousMenu';
import ProfileMenu from './ProfileMenu';

const filterAccessibleRoutes = (routes, user, parent, franchisor, centers) => {
    return routes.filter(route => {
        return (!route.businessFunctionName || authUtils.hasPermission(user, route.businessFunctionName)) && route.hasAccess(parent, centers, franchisor);
    });
};

const isMobileMenu = window.innerWidth < 768;

const MainMenu = ({ user, parent, franchisor, centers, languages, activeLanguage, onSelectLanguage, onLogout, t }) => {
    const routes = MAIN_MENU;
    return <div>
        <Nav pullRight>
            {filterAccessibleRoutes(routes, user, parent, franchisor, centers).map((route, index) =>
                route.submenus ? <NavDropdownHover id={index} key={index} title={
                    route.isProfile && !isMobileMenu ? <ProfileMenu user={user} parent={parent}/> :
                        <span>{t(route.textResourceKey)} <FontAwesome name='angle-down' /></span>
                } openOnHover={!isMobileMenu}>
                    {filterAccessibleRoutes(route.submenus, user, parent, franchisor, centers)
                        .map((subRoute, subIndex) =>
                            <IndexLinkContainer to={subRoute.path} key={subIndex}>
                                <MenuItem>{t(subRoute.textResourceKey)}</MenuItem>
                            </IndexLinkContainer>
                        )}
                    {route.isProfile && <MenuItem key='logOut' onSelect={onLogout}><FontAwesome name='sign-out' /> {t('FO_Login_Logout')}</MenuItem>}
                </NavDropdownHover> :
                    <IndexLinkContainer to={route.path} key={index}>
                        <NavItem>{t(route.textResourceKey)}</NavItem>
                    </IndexLinkContainer>
            )}
            {languages.length > 1 && <LanguageMenu isMobileMenu={isMobileMenu} languages={languages} activeLanguage={activeLanguage} onSelectLanguage={onSelectLanguage} style={{ marginTop: 50 }} />}
            {languages.length === 1 && activeLanguage && <NavItem><img src={require(`../../theme/images/lang/${activeLanguage.image}`)} /></NavItem>}
        </Nav>
    </div>;
};

export default withTranslation()(MainMenu);

export { AnonymousMenu };